<template>
  <LazyHomeCommonLayout>
    <template #content>
      <main class="subPage">
        <div class="backBg"></div>
        <LazyHomeSubPagesSupportContactUsInfo v-fade />
        <LazyHomeContentCP v-fade class="sub" />
      </main>
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {
  LazyHomeContentCP,
  LazyHomeSubPagesSupportContactUsInfo
} from "#components";

useHead({
  title: 'Contact Codepresso: We\'re Here to Assist',
  meta: [
    {
      name: 'description',
      content: "Reach out to us for any queries, support, or sales inquiries. Choose the right category, and our dedicated teams will promptly assist you."
    },
    {
      name: 'title',
      content: 'Contact Codepresso: We\'re Here to Assist'
    },
    {
      name: 'robots',
      content: 'index,follow'
    }
  ]
})
</script>
